<p-toast position="top-right"></p-toast>

<p-dialog
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="false"
    [visible]="showMerchantUploadDocumentSideBar"
    [style]="{width: '800px', height: '500px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <div class="header-title">{{headerTitleText}}</div>
        </div>
    </ng-template>
    <ng-template pTemplate="body">
        <div *ngIf="loading" style="text-align: center; padding: 30px;">
            <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                               fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
        </div>
        <div *ngIf="!loading">
            <p>Ensure your {{headerTitleText}} is valid and not expired before uploading. 
                For clarity, avoid using flash when taking a photo to keep the information clear and readable.</p>
            <div class="promo-detail-body">
                <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 177px)'}"
                               [styleClass]="'app-scrollpanel'">
                    
                    <div class="flex flex-row mud-block">
                        <div class="w-100">
                            <div class="flex flex-row mt-2">
                                <div class="mr-3 w-6" *ngIf="activeMerchantUploadDocumentType === merchantUploadDocumentTypeEnum.PersonalIdentification">
                                    <mat-form-field>
                                        <mat-label>ID Type</mat-label>
                                        <mat-select [(ngModel)]="document.PersonalIdType" required>
                                            <mat-option *ngFor="let personalIdType of personalIdTypes" [value]="personalIdType.value">{{personalIdType.name}}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="!document.PersonalIdType">This field is required.</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="flex flex-row mt-2">
                                <div class="mr-3 w-6" *ngIf="activeMerchantUploadDocumentType === merchantUploadDocumentTypeEnum.PersonalIdentification">
                                    <mat-form-field>
                                        <mat-label>Expiration Date</mat-label>
                                        <input matInput [min]="tomorrow" [matDatepicker]="picker" [(ngModel)]="document.ExpirationDate" (ngModelChange)="validateField($event)" required>
                                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        <mat-error *ngIf="!document.ExpirationDate">This field is required.</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="mr-3 w-6" *ngIf="activeMerchantUploadDocumentType !== merchantUploadDocumentTypeEnum.PersonalIdentification">
                                    <mat-form-field>
                                        <mat-label>Issue Date</mat-label>
                                        <input matInput [max]="today" [matDatepicker]="picker" [(ngModel)]="document.IssueDate" (ngModelChange)="validateField($event)" required>
                                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        <mat-error *ngIf="!document.IssueDate">This field is required.</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="w-6" *ngIf="activeMerchantUploadDocumentType !== merchantUploadDocumentTypeEnum.CompanyAuthorizationLetter">
                                    <mat-form-field>
                                        <mat-label>{{activeMerchantUploadDocumentType === merchantUploadDocumentTypeEnum.PersonalIdentification ? licenseNumber : labelDocumentNumber}}</mat-label>
                                        <input matInput  [(ngModel)]="document.DocumentNumber" (ngModelChange)="validateField($event)" placeholder="Enter here" required>
                                        <mat-error *ngIf="!document.DocumentNumber">This field is required.</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>  
                    <div class="flex flex-row">
                        <div [ngClass]="!document.imageUrl ? 'invalid-upload-field' : 'operator-add-vehicle-upload-field'" class="h-8rem"
                               *ngIf="!document.ImageUrl"
                               appDnd (fileDropped)="handleImageChange($event)">
                              <div class="operator-add-vehicle-upload-field__btn-block">
                                  <div *ngIf="!uploadInProgress" class="operator-add-vehicle-upload-field__title mb-3">Drop files here to upload</div>
                                  <div *ngIf="!uploadInProgress">
                                      <input style="display: none" accept=".jpg,.jpeg,.png" type="file" id="browseFile4" (change)="handleImageChange($event)">
                                      <label class="browse-btn" for="browseFile4">Browse File</label>
                                  </div>
                              </div>
                              <div *ngIf="uploadInProgress" class="mb-8 progress-cont">
                                  <div class="progress" [ngStyle]="{ width: progressBar + '%' }"></div>
                                  <span class="mb-2 percent-complete text-very-small">{{progressBar}}% Complete</span>
                              </div>
                          </div>
                          
                          <div class="operator-add-vehicle-upload-field h-8rem"
                               *ngIf="!uploadInProgress && document.ImageUrl">
                              <div class="mb-1 flex justify-content-between">
                                  <img src="{{document.ImageUrl}}" width="80px" alt="file" />
                              </div>
                          </div>
                    </div>
                    <mat-error *ngIf="!document.ImageUrl">This is required.</mat-error>
                </p-scrollPanel>
            </div>
    
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex justify-content-end mrg-10-0px">
            <button mat-button class="mr-3" (click)="cancel()">Cancel</button>
            <button [ngClass]="checkFields() ? 'btn-disabled' : 'submit-btn'" [disabled]="checkFields()" mat-button color="primary" (click)="clickUpload()">Upload</button>
        </div>
    </ng-template>
</p-dialog>
